import { createApp } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue';
import { router } from './router';
import { i18n } from './lib/i18n';
import { initSession } from './lib/session';
import { queryClient } from './lib/query';
import './styles/main.css';

/**
 * Session, THEN the router, then mount.
 *
 * `app.use(router)` starts the first navigation at once, and the guards read
 * `isSignedIn`. Installed before `initSession()` had loaded the stored OIDC
 * user, that first navigation saw everyone as signed out: deep links bounced
 * through the landing page, and members saw the paywall flash before being
 * sent on. (Development sign-in reads localStorage synchronously, which is why
 * only production showed it.)
 *
 * And mount only after `router.isReady()` — lasti.fi's rule: mounting earlier
 * renders once against an empty route.
 */
void (async () => {
  await initSession();
  const app = createApp(App).use(i18n).use(VueQueryPlugin, { queryClient }).use(router);
  await router.isReady();
  app.mount('#app');
})();
